import { createContext } from 'react'

export const RoundTableContext = createContext({
  eligible: false,
  ready: false,
  disabled: false,
  onChange: (() => Promise.resolve()) as (ready: boolean) => Promise<void>,
})
